// config/abbeyPainScaleConfig.js

export const SIGN_CHOICES = [
  { value: "0", name: "Absent - 0" },
  { value: 1, name: "Mild - 1" },
  { value: 2, name: "Moderate - 2" },
  { value: 3, name: "Severe - 3" },
];

export const PAIN_DESCRIPTION_OPTIONS = [
  { value: "Aching", label: "Aching" },
  { value: "Sharp", label: "Sharp" },
  { value: "Burning", label: "Burning" },
  { value: "Throbbing", label: "Throbbing" },
  { value: "Stabbing", label: "Stabbing" },
  { value: "Dull", label: "Dull" },
  { value: "Cramping", label: "Cramping" },
  { value: "Shooting", label: "Shooting" },
  { value: "Tingling", label: "Tingling" },
  { value: "Numbness", label: "Numbness" },
];

export const PAIN_WORSE_OPTIONS = [
  { value: "Movement", label: "Movement" },
  { value: "Cold weather", label: "Cold weather" },
  { value: "Hot weather", label: "Hot weather" },
  { value: "Stress", label: "Stress" },
  { value: "Sitting", label: "Sitting" },
  { value: "Standing", label: "Standing" },
  { value: "Walking", label: "Walking" },
  { value: "Lying down", label: "Lying down" },
  { value: "Touch", label: "Touch" },
  { value: "Pressure", label: "Pressure" },
  { value: "Eating", label: "Eating" },
  { value: "Noise", label: "Noise" },
  { value: "Light", label: "Light" },
];

export const PAIN_BETTER_OPTIONS = [
  { value: "Rest", label: "Rest" },
  { value: "Warm compress", label: "Warm compress" },
  { value: "Cold compress", label: "Cold compress" },
  { value: "Medication", label: "Medication" },
  { value: "Massage", label: "Massage" },
  { value: "Gentle movement", label: "Gentle movement" },
  { value: "Change of position", label: "Change of position" },
  { value: "Distraction", label: "Distraction" },
  { value: "Music", label: "Music" },
  { value: "Quiet environment", label: "Quiet environment" },
  { value: "Support", label: "Support" },
  { value: "Elevation", label: "Elevation" },
];

export const PAIN_CHRONIC_OPTIONS = [
  { value: "Chronic", name: "Chronit" },
  { value: "Acute", name: "Acute" },
  { value: "Acute on chronic", name: "Acute on chronic" },
  { value: "Do not know", name: "Do not know" },
  { value: "No pain", name: "No pain" },
];

export const initialFormData = {
  last_pain_relief: "",
  signs_of_crying: null,
  sign_of_crying_details: "",
  signs_of_tension: null,
  sign_of_tension_details: "",
  signs_of_fidgeting: null,
  sign_of_fidgeting_details: "",
  signs_of_confusion: null,
  sign_of_confusion_details: "",
  signs_of_temperature: null,
  sign_of_temperature_details: "",
  signs_of_skin_tears: null,
  sign_of_skin_tears_details: "",
  place_of_pain: "",
  cause_of_pain: "",
  pain_present_for: "",
  pain_chronic: "",
  comments: "",
  description_of_pain: [],
  make_pain_worse: [],
  make_pain_better: [],
};

export const abbeyPainLevels = [
  {
    label: "No Pain",
    scoreRange: "0",
    description:
      "No behavioral indicators of pain observed. Person appears comfortable and relaxed.",
  },
  {
    label: "Mild Pain",
    scoreRange: "1-3",
    description:
      "Minimal behavioral indicators present. Some mild discomfort may be observed but manageable.",
  },
  {
    label: "Moderate Pain",
    scoreRange: "4-13",
    description:
      "Moderate behavioral indicators of pain. Clear signs of discomfort requiring assessment and intervention.",
  },
  {
    label: "Severe Pain",
    scoreRange: "14-18",
    description:
      "Significant behavioral indicators of severe pain. Immediate pain management intervention required.",
  },
];
